import { format } from "date-fns";

export const getDefaultReportParams = () =>
  `f_periods=${format(new Date().setDate(0), "yyyy-MM")}`;
